import BreakdownGraph from './BreakdownGraph';

export default BreakdownGraph;
